import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, UntypedFormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { FiscalNumber } from "src/app/ui/models/domains/pbm/fiscal-number";
import { IndustryDiscountPageableResult } from "src/app/ui/models/domains/pbm/industry/industry-discount-pageable-result.model";
import { IndustryDiscountSearchParameters } from "src/app/ui/models/domains/pbm/industry/industry-discount-search-parameters.model";
import { IndustryDiscount } from "src/app/ui/models/domains/pbm/industry/industry-discount.model";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { LoadingService } from "src/app/ui/services/loading.service";
import { IndustryDiscountsService } from "src/app/ui/services/pbm/industry-discounts.service";
import { Toast } from "../../../toast/toast";

@Component({
  selector: "search-lpm-management",
  templateUrl: "./search-lpm-management.component.html",
  styleUrls: ["./search-lpm-management.component.scss"],
})
export class SearchLpmManagementComponent implements OnInit {
  public filterText: string;
  public searchType: UntypedFormControl;
  public fiscalNumberMask = MaskInput.getFicalNumberMask();
  private searchResult: IndustryDiscountPageableResult;
  private industryDiscountSearchParameters: IndustryDiscountSearchParameters;

  constructor(
    private featureViewService: FeatureViewService,
    private router: Router,
    private loadingService: LoadingService,
    private toast: Toast,
    private industryService: IndustryDiscountsService,
  ) {
    this.industryDiscountSearchParameters = new IndustryDiscountSearchParameters();
    this.searchType = new UntypedFormControl(1);
  }

  async ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.SearchLpmCompanies, PageViews.LpmManagementPageView);
    this.getIndustryDiscountSearch();
  }

  public async getIndustryDiscountSearch(): Promise<void> {
    const loadignRef = this.loadingService.beginLoading();

    try {
      const industryDiscountSearchParameters = new IndustryDiscountSearchParameters();
      industryDiscountSearchParameters.setStartIndex(0);
      industryDiscountSearchParameters.setTotalPerPages(10);

      this.searchResult = await this.industryService.getIndustryDiscountPageableResult(industryDiscountSearchParameters);
    } finally {
      loadignRef.closeLoading();
    }
  }

  public hasResult(): boolean {
    return !!this.searchResult;
  }

  public hasIndustries(): boolean {
    return !!this.searchResult && this.searchResult.getData().length > 0;
  }

  public getIndustries(): IndustryDiscount[] {
    return this.searchResult.getData();
  }

  public async searchIndustries(): Promise<void> {
    const loadingRef = this.loadingService.beginLoading();

    try {
      let fiscalNumber: string;

      if (this.filterText) {
        fiscalNumber = this.filterText.replace(/[./-]/g, "");
      } else {
        fiscalNumber = null;
      }

      this.industryDiscountSearchParameters.setStartIndex(0);
      this.industryDiscountSearchParameters.setTotalPerPages(10);
      this.industryDiscountSearchParameters.setFilterText(fiscalNumber);

      this.searchResult = await this.industryService.getIndustryDiscountPageableResult(this.industryDiscountSearchParameters);
    } catch (error) {
      this.toast.showWarningToast("Erro ao buscar industria!");
    } finally {
      loadingRef.closeLoading();
    }
  }

  public onPressEnterSearchCompanies(event): void {
    if (event.key === "Enter") this.searchIndustries();
  }

  public getResultQuantity(): string {
    if (!this.searchResult || this.searchResult.getData().length === 0) {
      return "Nenhum resultado encontrado.";
    }
    return `${this.searchResult.getData().length} resultado(s) encontrado(s)`;
  }

  public navigateToEdit(industryFiscalNumber: string): void {
    this.router.navigate([RoutePath.EditLpm, industryFiscalNumber]);
  }

  public hasMoreIndustriesToSearch(): boolean {
    return this.searchResult.getTotal() !== this.searchResult.getData().length && this.searchResult.getData().length > 1;
  }

  public async searchMoreIndustries() {
    const loadingRef = this.loadingService.beginLoading();
    try {
      const request = this.searchResult;
      this.industryDiscountSearchParameters.setStartIndex(request.getStart() + 10);
      const newSearchResult = await this.industryService.getIndustryDiscountPageableResult(this.industryDiscountSearchParameters);
      this.searchResult.getData().concat(newSearchResult.getData());
    } catch (error) {
      this.toast.showWarningToast("Erro ao buscar redes credenciadas");
    } finally {
      loadingRef.closeLoading();
    }
  }
}
